import React from 'react';

import { LayoutRow, LayoutRowProps } from '../layout-row/LayoutRow';

export const ActionsMenuFooter = (props: LayoutRowProps<{}>) => {
  return <LayoutRow justifyContent="end" withPadding="sm" spacedChildren="sm" {...props} />;
};
